import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-store-google-map',
  templateUrl: './store-google-map.component.html',
  styleUrls: ['./store-google-map.component.scss']
})
export class StoreGoogleMapComponent implements OnInit {

  @Input() storDetails: any;
  @Output() closeMap = new EventEmitter<void>();

  @ViewChild("myGoogleMap", { static: false })
  map!: ElementRef;
  center!: google.maps.LatLngLiteral;
  display: any;
  markers = [] as any;
  zoom = 14;

  constructor() { }

  ngOnInit(): void {
    let lng = this.storDetails?.lng;
    let lat = this.storDetails?.lat;

    console.log('lng - ', lng);
    console.log('lat - ', lat);
    console.log('this.storDetails - ', this.storDetails);

    if (lng && lat) {
        this.center = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };
        this.markers = {
            position: {
                lat: parseFloat(lat),
                lng: parseFloat(lng),
            },
            title: "Marker title ",
            info: "Marker info ",
            options: {
                draggable: false,
                animation: google.maps.Animation.DROP,
            },
        };
    }
  }

  addMarker(event: google.maps.MapMouseEvent) {
    if (event.latLng != null) {
        let postion = event.latLng.toJSON();
        this.center = {
            lat: postion.lat,
            lng: postion.lng,
        };
        this.markers = {
            position: {
                lat: postion.lat,
                lng: postion.lng,
            },
            options: {
                draggable: false,
                animation: google.maps.Animation.DROP,
            },
        };
    }
  }

  onCloseClick() {
    console.log('Close button clicked'); // Debugging log
    this.closeMap.emit(); // Emit event to notify parent
  }
}
